import { render, staticRenderFns } from "./AreaTableMenu.vue?vue&type=template&id=548cc0e2&scoped=true&"
import script from "./AreaTableMenu.vue?vue&type=script&lang=js&"
export * from "./AreaTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548cc0e2",
  null
  
)

export default component.exports